import { useTranslation } from 'react-i18next';
import { Input } from '@/components/ui/input';
import { Search } from 'lucide-react';

interface ExportHistoryHeaderProps {
  searchTerm: string;
  onSearchChange: (value: string) => void;
}

/**
 * Export History 下拉菜单头部组件
 * 显示标题和搜索输入框
 */
export function ExportHistoryHeader({ searchTerm, onSearchChange }: ExportHistoryHeaderProps) {
  const { t } = useTranslation('chrome');
  return (
    <div className="px-4 py-3 border-b space-y-2">
      <h3 className="text-sm font-semibold">{t('exportHistory.title')}</h3>
      <div className="relative">
        <Search className="absolute left-2 top-1/2 transform -translate-y-1/2 h-4 w-4 text-muted-foreground" />
        <Input
          type="text"
          placeholder={t('exportHistory.searchPlaceholder')}
          value={searchTerm}
          onChange={(e) => onSearchChange(e.target.value)}
          className="pl-8"
        />
      </div>
    </div>
  );
}
